import { Record as record } from 'immutable';

import trainTime from '../../../../lib/TrainTime';
import { getDefaults, getResolvers } from '../../../../helpers/Records';
import { construct, resolve, resolveAll } from '../../../../helpers/LinkMapper';

import Tap from './Tap';
import {
    KeyGoTapGenerationCause,
    KeyGoTapStatus,
    KeyGoTapTypes,
    KeyGoJourneyStates,
    IBlocksTransitModes
} from '../../../../constants/AppConstants';

const fieldSchema = {
    "journeyId": [resolve.with(Number)],
    "description": [resolve.with(String)],
    "originName": [resolve.with(String)],
    "destinationName": [resolve.with(String)],
    "route": [resolve.with(String)],
    "startTimestamp": [resolve.with(trainTime)],
    "endTimestamp": [resolve.with(trainTime)],
    "type": [resolve.with(String)],
    "state": [resolve.with(String)],
    "transitMode": [resolve.with(String)],
    "taps": [resolveAll.as(Tap)],
    "weeklyCapApplied": [resolve.with(Boolean)],
    "weeklySeasonSaving": [resolve.with(Number)]
};

class Journey extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(Journey, json, getResolvers(fieldSchema));
    }

    getTap (type = KeyGoTapTypes.ENTRY) {
        const tap = this.taps.find(t => t.type === type);
        return tap ? tap : new Tap({
            type: type,
            generationCause: KeyGoTapGenerationCause.UNKNOWN,
            status: KeyGoTapStatus.GENERATED
        });
    }

    isFinalIncomplete () {
        return this.state === KeyGoJourneyStates.INCOMPLETE_FINAL;
    }

    isProvisionalIncomplete () {
        return this.state === KeyGoJourneyStates.INCOMPLETE_PROVISIONAL;
    }

    isBus () {
        return this.transitMode.toUpperCase() === IBlocksTransitModes.BUS;
    }
}

export default Journey;
